export const convertWixSdkStateToPath = (appState) =>
  appState
    .split('/')
    .filter(Boolean)
    .map((part) => encodeURIComponent(part));
